import { ContactSearchResponseDTO } from "@/services/AuthService.interface"

// Vuex

import store from "@/store" 

const search = async (email: string) => {
	const response: ContactSearchResponseDTO | null =
		await store.dispatch("auth/search",{ email })
	return !!response?.userExists
}

export default search
